import Vue from 'vue'
export default {
  namespaced: true,
  state: () => ({
    doctors: {}
  }),
  getters: {
    doctors: state => Object.values(state.doctors),
    byId: state => id => {
      return state.doctors[id]
    }
  },
  mutations: {
    set (
      state,
      {
        id,
        firstname,
        lastname,
        busy,
        speciality_id,
        title,
        experience_from,
        chat,
        clinic_services,
        photo,
        country,
        gender,
        birthdate,
        language,
        languages,
        email,
        phone
      }
    ) {
      if (!state.doctors[id]) {
        Vue.set(state.doctors, id, {})
      }
      Vue.set(state.doctors[id], 'id', id)
      Vue.set(state.doctors[id], 'firstname', firstname)
      Vue.set(state.doctors[id], 'lastname', lastname)
      Vue.set(state.doctors[id], 'busy', busy)
      Vue.set(state.doctors[id], 'speciality_id', speciality_id)
      Vue.set(state.doctors[id], 'title', title)
      Vue.set(state.doctors[id], 'experience_from', experience_from)
      Vue.set(state.doctors[id], 'chat', chat)
      Vue.set(state.doctors[id], 'clinic_services', clinic_services)
      Vue.set(state.doctors[id], 'photo', photo)
      Vue.set(state.doctors[id], 'country', country)
      Vue.set(state.doctors[id], 'gender', gender)
      Vue.set(state.doctors[id], 'birthdate', birthdate)
      Vue.set(state.doctors[id], 'language', language)
      Vue.set(state.doctors[id], 'languages', languages)
      Vue.set(state.doctors[id], 'email', email)
      Vue.set(state.doctors[id], 'phone', phone)
    },
    reset (state) {
      state.doctors = {}
    }
  }
}
